import { z } from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    personalAccountDashboard: z.string().min(1),
    personalAccountUserManagement: z.string().min(1),
    personalAccountTrainerManagement: z.string().min(1),
    personalAccountManagement: z.string().min(1),
    personalAccountBookingCalendar: z.string().min(1),
    personalAccountBookingSetting: z.string().min(1),
    personalAccountWhatsApp: z.string().min(1),
    personalAccountCustomers: z.string().min(1),
    personalAccountBookingHistory: z.string().min(1),
    personalAccountPackages: z.string().min(1),
    personalAccountPackageManagement: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountIntegrations: z.string().min(1),
    accountAnalytics: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountMembershipApplications: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    accountManagement: z.string().min(1),
    accountWallets: z.string().min(1),
    accountBookingCalendar: z.string().min(1),
    accountDashboard: z.string().min(1),
    accountOnboarding: z.string().min(1),
    accountSetup: z.string().min(1),
    accountGuides: z.string().min(1),
    accountWhatsNew: z.string().min(1),
    accountPayments: z.string().min(1),
    accountCheckin: z.string().min(1),
    accountGuestPasses: z.string().min(1),
    accountBlacklist: z.string().min(1),
    accountGuestRules: z.string().min(1),
    accountNotifications: z.string().min(1),
    joinTeam: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
  },
  app: {
    home: '/home',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    personalAccountDashboard: '/home/dashboard',
    personalAccountUserManagement: '/home/user-management',
    personalAccountTrainerManagement: '/home/resources',
    personalAccountManagement: '/home/management',
    personalAccountBookingCalendar: '/home/booking-calendar',
    personalAccountBookingSetting: '/home/settings',
    personalAccountWhatsApp: '/home/whatsapp',
    personalAccountCustomers: '/home/customers',
    personalAccountBookingHistory: '/home/booking-history',
    personalAccountPackages: '/home/packages',
    personalAccountPackageManagement: '/home/package-management',

    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    accountIntegrations: `/home/[account]/settings/integrations`,
    accountAnalytics: `/home/[account]/settings/analytics`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountMembershipApplications: `/home/[account]/memberships/applications`,
    accountBillingReturn: `/home/[account]/billing/return`,
    accountManagement: `/home/[account]/management`,
    accountWallets: '/home/[account]/wallet',
    accountBookingCalendar: '/home/[account]/booking-calendar',
    accountDashboard: '/home/[account]/dashboard',
    accountOnboarding: '/home/[account]/onboarding',
    accountSetup: '/home/[account]/setup',
    accountGuides: '/home/[account]/onboarding/guides',
    accountWhatsNew: '/home/[account]/whats-new',
    accountPayments: '/home/[account]/payments',
    accountCheckin: '/home/[account]/checkin',
    accountGuestPasses: '/home/[account]/guest-passes',
    accountBlacklist: '/home/[account]/blacklist',
    accountGuestRules: '/home/[account]/settings/guest-rules',
    accountNotifications: '/home/[account]/notifications',
    joinTeam: '/join',
  },
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;
